import { render, staticRenderFns } from "./vehicledetailsTax.vue?vue&type=template&id=05e774d6"
import script from "./vehicledetailsTax.vue?vue&type=script&lang=js"
export * from "./vehicledetailsTax.vue?vue&type=script&lang=js"
import style0 from "./vehicledetailsTax.vue?vue&type=style&index=0&id=05e774d6&prod&lang=css"
import style1 from "./vehicledetailsTax.vue?vue&type=style&index=1&id=05e774d6&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports